module.exports = __webpack_public_path__ + "img/img_03.c65caa95.png";